export const getPOFormVendorProps = () => {
    return {
        id: 'vendorId',
        label: 'Vendor Name',
        name: 'vendorId',
        searchPlaceholder: "Search By Vendor Name",
        noDataLabel: "No Vendor Name Found",
        width: '100%',
        listWidth: 450,
        allOption: false,
        isCompulsory: true,
        singleSelect: true,
        selectedValues: [],
        isFormikFormField: true,
        showFormError: false,
        prevId: '',
        nextId: '',
        onSelect: () => { },
        onRemove: () => { }
    }
}

export const getBranchFormProps = () => {
    return {
        id: 'branchId',
        label: 'Branch',
        name: 'branchId',
        searchPlaceholder: "Search By Branch Name",
        noDataLabel: "No Branch Found",
        width: '100%',
        listWidth: 418,
        allOption: false,
        isCompulsory: true,
        singleSelect: true,
        isFormikFormField: true,
        selectedValues: [],
        prevId: '',
        nextId: '',
    }
}

export const getCategoryFormProps = () => {
    return {
        id: 'categoryId',
        label: 'Category',
        name: 'categoryId',
        searchPlaceholder: "Search By Item Category",
        noDataLabel: "No Item Category Found",
        width: '100%',
        listWidth: 418,
        allOption: false,
        isCompulsory: true,
        singleSelect: true,
        isFormikFormField: true,
        isParent: "Y",
        selectedValues: [],
        prevId: '',
        nextId: '',
    }
}

export const getBrandFormProps = () => {
    return {
        id: 'brandId',
        label: 'Brand',
        name: 'brandId',
        searchPlaceholder: "Search By Item Brand",
        noDataLabel: "No Item Brand Found",
        width: '100%',
        listWidth: 418,
        allOption: false,
        isCompulsory: true,
        singleSelect: true,
        isFormikFormField: true,
        selectedValues: [],
        prevId: '',
        nextId: '',
    }
}

export const getItemFormProps = () => {
    return {
        id: 'itemId',
        label: 'Item',
        name: 'itemId',
        searchPlaceholder: "Search By Item Name",
        noDataLabel: "No Item Name Found",
        width: '100%',
        listWidth: 600,
        allOption: false,
        isCompulsory: true,
        singleSelect: true,
        isFormikFormField: true,
        selectedValues: [],
    }
}

export const getSerialNoFormProps = () => {
    return {
        id: 'serialNoId',
        label: 'Serial No',
        name: 'serialNoId',
        searchPlaceholder: "Search By Item Name",
        noDataLabel: "No Item Name Found",
        width: '100%',
        listWidth: 300,
        allOption: false,
        isCompulsory: true,
        singleSelect: true,
        isFormikFormField: true,
        selectedValues: [],
    }
}

export const getActivityFormProps = () => {
    return {
        id: 'jobCategoryId',
        label: 'Activity',
        name: 'jobCategoryId',
        searchPlaceholder: "Search By Activity Name",
        noDataLabel: "No Activity Name Found",
        width: '100%',
        listWidth: 350,
        allOption: false,
        isCompulsory: true,
        singleSelect: true,
        isFormikFormField: true,
        selectedValues: [],
    }
}

export const getUserFormProps = () => {
    return {
        id: 'staffId',
        label: 'Assign',
        name: 'staffId',
        searchPlaceholder: "Search By User Name",
        noDataLabel: "No User Name Found",
        width: '100%',
        listWidth: 350,
        allOption: false,
        isCompulsory: true,
        singleSelect: true,
        isFormikFormField: true,
        selectedValues: [],
        prevId: '',
        nextId: '',
    }
}

export const getStockKeepingUnitFormProps = () => {
    return {
        id: 'unitId',
        label: 'UoM',
        name: 'unitId',
        searchPlaceholder: "Search By Unit Name",
        noDataLabel: "No Unit Name Found",
        width: '100%',
        listWidth: 350,
        allOption: false,
        isCompulsory: true,
        singleSelect: true,
        isFormikFormField: true,
        selectedValues: [],
        prevId: '',
        nextId: '',
    }
}

export const getModeOfPaymentFormProps = () => {
    return {
        id: 'modeOfPayment',
        label: 'Mode of Payment',
        name: 'modeOfPayment',
        searchPlaceholder: "Search By Mode of Payment",
        noDataLabel: "No Payment Mode Found",
        width: '100%',
        listWidth: 250,
        allOption: false,
        isCompulsory: true,
        singleSelect: true,
        isFormikFormField: true,
        selectedValues: [],
        prevId: '',
        nextId: '',
        onSelect: () => { },
        onRemove: () => { },
    }
}


export const getStoreFormProps = () => {
    return {
        id: 'storeId',
        label: 'Store',
        name: 'storeId',
        searchPlaceholder: "Search By Store",
        noDataLabel: "No Store Found",
        width: '100%',
        listWidth: 300,
        allOption: false,
        isCompulsory: true,
        singleSelect: true,
        selectedValues: [],
        isFormikFormField: true,
        showFormError: false,
        prevId: '',
        nextId: '',
        onSelect: () => { },
        onRemove: () => { }
    }
}

export const getStockKeepingUnitProps = () => {
    return {
        id: 'unitId',
        label: "UoM",
        name: 'unitId',
        searchPlaceholder: "Search By UoM",
        noDataLabel: "No UoM Found",
        width: '100%',
        listWidth: 350,
        allOption: false,
        isCompulsory: true,
        singleSelect: true,
        isFormikFormField: true,
        selectedValues: [],
    }
}

export const getVendorCategoriesProps = () => {
    return {
        id: 'superCategories',
        label: 'Super Category',
        name: 'superCategories',
        searchPlaceholder: "Search By Super Categories",
        noDataLabel: "No Super Category Found",
        width: '100%',
        allOption: false,
        isCompulsory: true,
        singleSelect: false,
        isFormikFormField: true,
        selectedValues: [],
        onSelect: () => { },
        onRemove: () => { },
    }
}

export const getTyreTubeTypeFormProps = () => {
    return {
        id: 'tubeTypeId',
        label: 'Tube',
        name: 'tubeTypeId',
        searchPlaceholder: "Search By Tube Type",
        noDataLabel: "No Tube Type Found",
        width: '100%',
        listWidth: 250,
        allOption: false,
        isCompulsory: true,
        singleSelect: true,
        selectedValues: [],
        isFormikFormField: false,
        showFormError: false,
        prevId: '',
        nextId: '',
        onSelect: () => { },
        onRemove: () => { }
    }
}

export const getPONumberProps = () => {
    return {
        id: 'id',
        label: "PO No.",
        name: 'poNo',
        searchPlaceholder: "Search By PO Number",
        noDataLabel: "No PO Number Found",
        width: '100%',
        listWidth: 300,
        allOption: false,
        isCompulsory: true,
        singleSelect: true,
        selectedValues: [],
        isFormikFormField: true,
        showFormError: false,
        prevId: '',
        nextId: '',
        onSelect: () => { },
        onRemove: () => { }
    }
}





export const getBatteryTypeFormProps = () => {
    return {
        id: 'batteryTypeId',
        label: 'Battery Type',
        name: 'batteryTypeId',
        searchPlaceholder: "Search By Battery Type",
        noDataLabel: "No Battery Type Found",
        width: '100%',
        listWidth: 300,
        allOption: false,
        isCompulsory: true,
        singleSelect: true,
        selectedValues: [],
        isFormikFormField: true,
        showFormError: false,
        prevId: '',
        nextId: '',
        onSelect: () => { },
        onRemove: () => { }
    }
}

export const getItemSubCategoryProps = () => {
    return {
        id: 'itemSubCategory',
        label: 'Item Sub Category',
        name: 'itemSubCategory',
        searchPlaceholder: "Search By Item Sub Category",
        noDataLabel: "No Item Sub Category Found",
        width: '300px',
        listWidth: 350,
        categoryFor: 1,
        isParent: 'N',
        allOption: false,
        isCompulsory: false,
        singleSelect: true,
        isFormikFormField: true,
        selectedValues: [],
    }
}

export const getCategoryProps = () => {
    return {
        id: 'categoryId',
        label: 'Category',
        name: 'categoryId',
        width: '300px',
        searchPlaceholder: "Search By Category",
        noDataLabel: "No Category Found",
        categoryFor: 1,
        listWidth: 350,
        isParent: 'Y',
        allOption: false,
        isCompulsory: true,
        singleSelect: true,
        isFormikFormField: true,
        selectedValues: [],
    }
}
export const getSubCategoryProps = () => {
    return {
        id: 'categoryId',
        label: 'Category',
        name: 'categoryId',
        width: '300px',
        searchPlaceholder: "Search By Category",
        noDataLabel: "No Category Found",
        categoryFor: 1,
        listWidth: 350,
        isParent: 'Y',
        allOption: false,
        isCompulsory: true,
        singleSelect: true,
        isFormikFormField: true,
    }
}

export const dueScheduledTasksDurationProps = () => {
    return {
        id: 'dueScheduledTasksId',
        label: 'Due Scheduled Tasks Duration',
        name: 'dueScheduledTasksId',
        searchPlaceholder: "Search By Due Scheduled Tasks Duration",
        noDataLabel: "No Due Scheduled Tasks Duration Found",
        width: '100%',
        listWidth: 250,
        allOption: false,
        isCompulsory: true,
        singleSelect: true,
        selectedValues: [],
        isFormikFormField: false,
        showFormError: false,
        prevId: '',
        nextId: '',
    }
}

export const taskandServiceTaskProps = () => {
    return {
        name: "taskId",
        isCompulsory: true,
        singleSelect: true,
        label: "Task",
        searchPlaceholder: "Search By Task",
        noDataLabel: "No Task Found",
        listWidth: 400,
        isFormikFormField: true,
        showFormError: false,
    }
}

export const getServiceTaskNameProps = () => {
    return {
        id: 'serviceTaskId',
        prevId: '',
        nextId: '',
        label: 'Service Task Name',
        name: 'serviceTaskId',
        searchPlaceholder: "Search By Service Task Name",
        noDataLabel: "No Service Task Found",
        width: '100%',
        listWidth: 350,
        categoryFor: 1,
        allOption: false,
        isCompulsory: false,
        singleSelect: true,
        isFormikFormField: true,
        selectedValues: [],
    }
}

export const getVehicleMakeProps = () => {
    return {
        id: 'vehicleOemId',
        prevId: '',
        nextId: '',
        label: 'Vehicle Make (OEM)',
        name: 'vehicleOemId',
        searchPlaceholder: "Search By Vehicle Make",
        noDataLabel: "No Vehicle Make Found",
        width: '100%',
        listWidth: 350,
        allOption: true,
        isCompulsory: false,
        singleSelect: true,
        isFormikFormField: true,
        selectedValues: [],
        onSelect: () => { },
        onRemove: () => { }
    }
}

export const getVehicleModelProps = () => {
    return {
        id: 'vehicleModelId',
        prevId: '',
        nextId: '',
        label: 'Vehicle Model',
        name: 'vehicleModelId',
        searchPlaceholder: "Search By Vehicle Model",
        noDataLabel: "No Vehicle Model Found",
        width: '100%',
        listWidth: 450,
        allOption: true,
        isCompulsory: false,
        singleSelect: true,
        isFormikFormField: true,
        selectedValues: [],
        onSelect: () => { },
        onRemove: () => { }
    }
}

export const getVehicleProps = () => {
    return {
        id: 'vehicleNumber',
        prevId: '',
        nextId: '',
        label: 'Vehicle No',
        name: 'vehicleNumber',
        searchPlaceholder: "Search By Vehicle Number",
        noDataLabel: "No Vehicle Found",
        width: '100%',
        listWidth: 250,
        allOption: false,
        isCompulsory: false,
        singleSelect: false,
        isFormikFormField: true,
        selectedValues: [],
        onSelect: () => { },
        onRemove: () => { }
    }
}

export const getStatusProps = () => {
    return {
        id: 'statusId',
        prevId: '',
        nextId: '',
        label: 'Status',
        name: 'statusId',
        searchPlaceholder: "Search By Status",
        noDataLabel: "No Status Found",
        width: '100%',
        listWidth: 250,
        allOption: false,
        isCompulsory: false,
        singleSelect: true,
        isFormikFormField: true,
        selectedValues: [1],
        onSelect: () => { },
        onRemove: () => { }
    }
}

export const getNumberProps = () => {
    return {
        id: 'numberId',
        prevId: '',
        nextId: '',
        label: 'Number',
        name: 'numberId',
        searchPlaceholder: "Search By Number",
        noDataLabel: "No Number Found",
        width: '100%',
        listWidth: 250,
        allOption: false,
        isCompulsory: false,
        singleSelect: true,
        isFormikFormField: true,
        selectedValues: [],
        onSelect: () => { },
        onRemove: () => { }
    }
}

export const getPeriodModesProps = () => {
    return {
        id: 'id',
        prevId: '',
        nextId: '',
        label: 'Duration',
        name: 'label',
        width: '100%',
        listWidth: "160px",
        allOption: false,
        isCompulsory: true,
        singleSelect: true,
        isFormikFormField: true,
        selectedValues: [1],
        onSelect: () => { },
        onRemove: () => { },
    }
}

export const getHoursProps = () => {
    return {
        id: 'hoursId',
        prevId: '',
        nextId: '',
        label: 'HH',
        name: 'hoursId',
        searchPlaceholder: "Search By Hours",
        noDataLabel: "No Hours Found",
        width: '100%',
        listWidth: 250,
        allOption: false,
        isCompulsory: false,
        singleSelect: true,
        isFormikFormField: true,
        selectedValues: [0],
    }
}

export const getMinutesProps = () => {
    return {
        id: 'minutsId',
        prevId: '',
        nextId: '',
        label: 'MM',
        name: 'minutsId',
        searchPlaceholder: "Search By Minutes",
        noDataLabel: "No Minutes Found",
        width: '100%',
        listWidth: 250,
        allOption: false,
        isCompulsory: false,
        singleSelect: true,
        isFormikFormField: true,
        selectedValues: [0],
    }
}
export const getPendingStockTransferRequestProps = () => {
    return {
        id: "searchSTKTRReqNo",
        label: "Transfer Request No",
        name: "searchSTKTRReqNo",
        searchPlaceholder: "Search By Pending Stock Transfer Request",
        noDataLabel: "No Request Found",
        listWidth: 500,
        allOption: false,
        isCompulsory: false,
        singleSelect: true,
        selectedValues: [],
    };
};
export const getRequestApprovedByProps = () => {
    return {
        id: "searchRequestApprovedBy",
        label: "Request Approved By",
        name: "searchRequestApprovedBy",
        searchPlaceholder: "Search By Request Approved By",
        noDataLabel: "No Name Found",
        width: 190,
        listWidth: 450,
        allOption: false,
        isCompulsory: false,
        singleSelect: false,
        selectedValues: [0],
    };
};
export const getRequestCreatedByProps = () => {
    return {
        id: "searcheRequestCreatedBy",
        label: "Request Created by",
        name: "searchRequestCreatedBy",
        searchPlaceholder: "Search Request Created by",
        noDataLabel: "No Name Found",
        width: 180,
        listWidth: 450,
        allOption: false,
        isCompulsory: false,
        singleSelect: false,
        selectedValues: [0],
    };
};
export const getTransferRequestStatusProps = () => {
    return {
        id: "searchTransferRequestStatus",
        label: "Status",
        name: "searchTransferRequestStatus",
        searchPlaceholder: "Search By Transfer Request Status",
        noDataLabel: "No Transfer Request Status Found",
        width: 180,
        listWidth: 300,
        allOption: false,
        isCompulsory: false,
        singleSelect: false,
        selectedValues: [],
    };
};
export const getTransferToStoreProps = () => {
    return {
        id: "searchTransferToStore",
        label: "Transfer To Store",
        name: "searchTransferToStore",
        searchPlaceholder: "Search By Transfer To Store",
        noDataLabel: "No Transfer To Store Found",
        listWidth: 300,
        allOption: false,
        isCompulsory: false,
        singleSelect: true,
        selectedValues: [],
    };
};
export const getTransferRequestFromStoreProps = () => {
    return {
        id: "searchRequestFromStore",
        label: "Request From Store",
        name: "searchRequestFromStore",
        searchPlaceholder: "Search By Request From Store",
        noDataLabel: "No Request From Store Found",
        listWidth: 300,
        allOption: false,
        isCompulsory: false,
        singleSelect: true,
        selectedValues: [],
    };
};

export const getTransferVoucherStatusProps = () => {
    return {
        id: "searchTransferVoucherStatus",
        label: "Status",
        name: "searchTransferVoucherStatus",
        searchPlaceholder: "Search By Transfer Voucher Status",
        noDataLabel: "No Transfer Request Voucher Found",
        listWidth: 300,
        allOption: false,
        isCompulsory: false,
        singleSelect: false,
        selectedValues: [],
    };
};

export const getCountryProps = () => {
    return {
        id: 'countryId',
        label: 'Country',
        name: 'countryId',
        searchPlaceholder: "Search By Country Name",
        noDataLabel: "No Country Found",
        allOption: false,
        isCompulsory: false,
        singleSelect: true,
        isFormikFormField: false,
    }
}

export const getStateProps = () => {
    return {
        id: 'stateId',
        label: 'State',
        name: 'stateId',
        searchPlaceholder: "Search By State Name",
        noDataLabel: "No State Found",
        width: "100%",
        listWidth: "300px",
        allOption: false,
        isCompulsory: true,
        singleSelect: true,
        isFormikFormField: false,
        // selectedValues: editData ? [editData.stateId] : [],
    }
}

export const getCityProps = () => {
    return {
        id: 'cityId',
        label: 'City',
        name: 'cityId',
        searchPlaceholder: "Search By City Name",
        noDataLabel: "No City Found",
        width: "100%",
        listWidth: "300px",
        allOption: false,
        isCompulsory: true,
        singleSelect: true,
        isFormikFormField: false,
        // selectedValues: editData ? [editData.cityId] : [],
    }
}

export const getFilterStatusProps = () => {
    return {
        id: 'acstatus',
        label: 'Select Status',
        name: 'acstatus',
        searchPlaceholder: "Search By Status",
        noDataLabel: "No Status Found",
        listWidth: 250,
        allOption: true,
        isCompulsory: false,
        singleSelect: true,
        selectedValues: [-1],
        // onSelect: handleStatusChanged,
        // onRemove: handleStatusChanged
    }
}

export const getSearchFuelTypeProps = () => {
    return {
        id: 'id',
        prevId: '',
        nextId: '',
        label: 'Fuel Type',
        name: 'id',
        searchPlaceholder: "Search By Fuel Type",
        noDataLabel: "No Fuel Type Found",
        width: '100%',
        listWidth: 250,
        allOption: true,
        isCompulsory: false,
        singleSelect: false,
        selectedValues: [],
    }
}

export const getSearchFuelStationProps = () => {
    return {
        id: 'fuelStationId',
        prevId: '',
        nextId: '',
        label: 'Fuel Station Name',
        name: 'fuelStationId',
        searchPlaceholder: "Search By Fuel Station Name",
        noDataLabel: "No Fuel Station Found",
        width: '100%',
        listWidth: 350,
        allOption: true,
        isCompulsory: false,
        singleSelect: false,
        selectedValues: [],
    }
}

export const getDriversProps = () => {
    return {
        listWidth: 350,
        isCompulsory: false,
        singleSelect: true,
        searchPlaceholder: "Search By Driver Name",
        noDataLabel: "No Drivers Found",
        isFormikFormField: true,
        showFormError: false,
    }
}

export const getSearchFuelFromProps = () => {
    return {
        id: 'id',
        prevId: '',
        nextId: '',
        label: 'Fuel From',
        name: 'id',
        searchPlaceholder: "Search By Fuel From",
        noDataLabel: "No Result Found",
        width: '100%',
        listWidth: 250,
        allOption: true,
        isCompulsory: false,
        singleSelect: true,
        selectedValues: [],
    }
}

export const getRSConditionProps = () => {
    return {
        id: 'dismountCondition',
        label: 'Condition',
        name: 'dismountCondition',
        searchPlaceholder: "Search By Dismount Condition",
        noDataLabel: "No IDismount Condition Found",
        width: '100%',
        listWidth: 250,
        allOption: false,
        isCompulsory: true,
        singleSelect: true,
        isFormikFormField: true,
        selectedValues: [],
    }
}